var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInterested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6544_104842",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6544_104842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 11.667C13.3056 11.667 13.4236 11.6184 13.5208 11.5212C13.6181 11.4239 13.6667 11.3059 13.6667 11.167C13.6667 11.0281 13.6181 10.91 13.5208 10.8128C13.4236 10.7156 13.3056 10.667 13.1667 10.667C13.0278 10.667 12.9097 10.7156 12.8125 10.8128C12.7153 10.91 12.6667 11.0281 12.6667 11.167C12.6667 11.3059 12.7153 11.4239 12.8125 11.5212C12.9097 11.6184 13.0278 11.667 13.1667 11.667ZM10.8333 11.667C10.9722 11.667 11.0903 11.6184 11.1875 11.5212C11.2847 11.4239 11.3333 11.3059 11.3333 11.167C11.3333 11.0281 11.2847 10.91 11.1875 10.8128C11.0903 10.7156 10.9722 10.667 10.8333 10.667C10.6944 10.667 10.5764 10.7156 10.4792 10.8128C10.3819 10.91 10.3333 11.0281 10.3333 11.167C10.3333 11.3059 10.3819 11.4239 10.4792 11.5212C10.5764 11.6184 10.6944 11.667 10.8333 11.667ZM12 12.5003C11.6222 12.5003 11.2792 12.6073 10.9708 12.8212C10.6625 13.035 10.4389 13.317 10.3 13.667H13.7C13.5611 13.317 13.3375 13.035 13.0292 12.8212C12.7208 12.6073 12.3778 12.5003 12 12.5003ZM12 15.3337C11.5389 15.3337 11.1056 15.2462 10.7 15.0712C10.2944 14.8962 9.94167 14.6587 9.64167 14.3587C9.34167 14.0587 9.10417 13.7059 8.92917 13.3003C8.75417 12.8948 8.66667 12.4614 8.66667 12.0003C8.66667 11.5392 8.75417 11.1059 8.92917 10.7003C9.10417 10.2948 9.34167 9.94199 9.64167 9.64199C9.94167 9.34199 10.2944 9.10449 10.7 8.92949C11.1056 8.75449 11.5389 8.66699 12 8.66699C12.4611 8.66699 12.8944 8.75449 13.3 8.92949C13.7056 9.10449 14.0583 9.34199 14.3583 9.64199C14.6583 9.94199 14.8958 10.2948 15.0708 10.7003C15.2458 11.1059 15.3333 11.5392 15.3333 12.0003C15.3333 12.4614 15.2458 12.8948 15.0708 13.3003C14.8958 13.7059 14.6583 14.0587 14.3583 14.3587C14.0583 14.6587 13.7056 14.8962 13.3 15.0712C12.8944 15.2462 12.4611 15.3337 12 15.3337Z",
    fill: "#FF453A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9123 6.33498L3.69254 2.09439C3.262 1.91572 2.77562 1.99432 2.42318 2.29941C2.07074 2.60455 1.92334 3.07467 2.03853 3.52637L3.04281 7.46471L2.03853 11.403C1.92334 11.8547 2.07072 12.3249 2.42316 12.63C2.77626 12.9357 3.26277 13.0133 3.69254 12.835L7.385 11.3029C7.72138 9.05606 9.65947 7.33301 12 7.33301C12.9251 7.33301 13.7874 7.6022 14.5127 8.06653C14.6123 7.88846 14.6667 7.68325 14.6667 7.46471C14.6667 6.96094 14.3776 6.52804 13.9123 6.33498Z",
    fill: "#656E83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterested);
export default __webpack_public_path__ + "static/media/notInterested.098373e0d1fe3ee2dff01adbc814a961.svg";
export { ForwardRef as ReactComponent };